<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="用户名">
              <b-input placeholder="输入用户名模糊查询" v-model="queryParam.username"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="状态">
              <a-select
                v-model="queryParam.status"
                :options="statusTypeList"
              ></a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => queryParam = {}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button @click="$refs.userAddOrUpdate.init('','add')" icon="plus" type="primary" v-action="'sys:user:save'">新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>
          <!-- lock | unlock -->
          <a-menu-item key="2"><a-icon type="lock" />锁定</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
    <s-table
      bordered
      ref="table"
      :alert="alert"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.userId"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="status" slot-scope="text,record">
        <a-tag color="#108ee9">{{ text | dictFilter(statusTypeList) }}</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <span v-action="'sys:user:update'">
          <a href="javascript:;" @click="edit(record)">编辑</a>
          <a-divider type="vertical" />
        </span>
        <span v-action="'sys:user:del'">
          <a-popconfirm title="是否删除用户" @confirm="deleteItem(record)" okText="是" cancelText="否">
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <a href="javascript:;" style="color: red">删除</a>
          </a-popconfirm>
          <a-divider type="vertical" />
        </span>
        <span v-action="'sys:user:info'">
          <a href="javascript:;"@click="show(record)">查看</a>
        </span>
      </span>
    </s-table>
    <user-add-or-update
      @ok="queryPage"
      ref="userAddOrUpdate"
    />
  </a-card>
</template>

<script>
import { fetchList, delObj } from '@api/sys/user'
import UserAddOrUpdate from './userAddOrUpdate'
import BInput from '@/components/BootComp/BInput'
import { TableMixin } from '@/mixins/TableMixin'
import { statusTypeList } from '@/dict'
import { enterEvent } from '@/utils/util'
export default {
  name: 'User',
  mixins: [TableMixin],
  components: {
    UserAddOrUpdate,
    BInput
  },
  data () {
    return {
      description: '创建可登录用户，以及分配对应的角色',
      statusTypeList,
      columns: [
        {
          title: '#',
          width: '10%',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        }, {
          title: '用户名',
          sorter: true,
          dataIndex: 'username'
        }, {
          title: '所在部门',
          dataIndex: 'deptId_dictText'
        }, {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        }, {
          title: '手机号',
          width: '10%',
          sorter: true,
          dataIndex: 'phone'
        }, {
          title: '角色',
          width: '15%',
          dataIndex: 'roleList',
          customRender: (record) => {
            return (
              <div>
                {
                  record.map(item => {
                    return <a-tag color="#108ee9">{item.roleName} </a-tag>
                  })
                }
              </div>
            )
          }
        },
        {
          title: '操作',
          width: '200px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      queryParam: {
        username: '',
        status: ''
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      }
    }
  },
  methods: {
    edit (record) {
      this.$refs.userAddOrUpdate.init(record.userId, 'edit')
    },
    deleteItem (record) {
      delObj(record.userId).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    },
    show (record) {
      this.$refs.userAddOrUpdate.init(record.userId, 'show')
    }
  },
  created () {
    enterEvent(this.queryPage)
  }
}
</script>

<style scoped>

</style>
